import Image from 'app/Components/Shared/Image/image';
import React, { useState, useEffect ,useRef } from 'react';
import { useSelector } from 'react-redux';
import closeIcon from './images/close-icon.svg';

const LeadAgreementsTooltip =  ({ sendTooltipStatus, ...props }) => {

  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);
  const initApp = useSelector((state) => state.initApp);

  const defaulText  = initApp?.potentialCustomerDefaulText || props?.leadAgreementsData?.defaulText || '';
  const tooltipText = initApp?.potentialCustomerTooltipText || props?.leadAgreementsData?.tooltipText || '';
  const bottomText  = initApp?.potentialCustomerBottomText || props?.leadAgreementsData?.bottomText || '';
  const textButton = initApp?.potentialCustomerTextButton || props?.leadAgreementsData?.textButton || 'עוד';

  var additionalBottomText = props.additionalBottomText;

  const handleExtendedTextButtonClick = () => {
    setIsTooltipOpen(!isTooltipOpen);
    setIsOverlayOpen(!isOverlayOpen);

    if (typeof sendTooltipStatus === 'function') {
      sendTooltipStatus(!isTooltipOpen);
    }
  };

  return (
    <div className='lead-agreements-content'>
        {defaulText && (
        <>
          <span dangerouslySetInnerHTML={{ __html: defaulText }}></span>{' '}
          <span className='extended-text-button' onClick={handleExtendedTextButtonClick}>
            {textButton}
          </span>
          <br />
          <span dangerouslySetInnerHTML={{ __html: bottomText }}></span>
        </>
        )}
        {isOverlayOpen && (
          <div className={`lead-tooltip ${additionalBottomText}`}>
            <div className="lead-tooltip-content">
              <span className="close-tooltip" onClick={handleExtendedTextButtonClick}><Image src={closeIcon} alt="Close" /></span>
              <span className="extended-text" dangerouslySetInnerHTML={{ __html: tooltipText }}></span>
            </div>
          </div>
        )}
      </div>
  );
};

export default LeadAgreementsTooltip;
